import React from 'react';
import { SunIcon, CalendarIcon, ArrowRightIcon, AlertCircleIcon } from 'lucide-react';
export function SportingClaysSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#ffffff'
  }} aria-label="Sporting Clays" data-id="element-446">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-447">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start" data-id="element-448">
          {/* Image */}
          <div className="w-full lg:w-2/5 flex-shrink-0" data-id="element-449">
            <div className="relative rounded-2xl overflow-hidden" style={{
            aspectRatio: '4/3'
          }} data-id="element-450">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Front%20Page/Steel%20Challenge%20Generic%2024.jpg" alt="Sporting Clays course at FLSC" className="w-full h-full object-cover" data-id="element-451" />
              <div className="absolute bottom-0 left-0 right-0 p-4" style={{
              background: 'linear-gradient(to top, rgba(15,35,24,0.9) 0%, transparent 100%)'
            }} data-id="element-452">
                <p className="text-sm font-bold uppercase" style={{
                color: '#c8a84b',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-453">
                  16-Station Course · 1 Mile
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1" data-id="element-454">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-455">
              Featured Activity
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-456">
              Sporting Clays Shooters
            </h2>
            <div className="section-divider" data-id="element-457" />

            <p className="text-base leading-relaxed mb-6" style={{
            color: '#3a3a3a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-458">
              Our 16-station Sporting Clays course winds through a heavily
              wooded one-mile stretch of FLSC property — one of the finest
              courses in the region. Whether you're a seasoned competitor or a
              first-timer, you'll find a challenge here.
            </p>

            <div className="space-y-4 mb-8" data-id="element-459">
              <div className="flex items-start gap-3 p-4 rounded-xl" style={{
              backgroundColor: '#f0f7f3',
              border: '1px solid #d6ebe0'
            }} data-id="element-460">
                <SunIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#2d5a3d'
              }} data-id="element-461" />
                <div data-id="element-462">
                  <p className="text-sm font-semibold mb-0.5" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-463">
                    Public Access — Saturdays &amp; Sundays
                  </p>
                  <p className="text-sm" style={{
                  color: '#5a5a5a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-464">
                    Open to the public beginning at 10:00 AM; last line out at
                    2:00 PM.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 rounded-xl" style={{
              backgroundColor: '#f0f7f3',
              border: '1px solid #d6ebe0'
            }} data-id="element-465">
                <CalendarIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#2d5a3d'
              }} data-id="element-466" />
                <div data-id="element-467">
                  <p className="text-sm font-semibold mb-0.5" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-468">
                    Red Key Holders — Weekdays (Spring through Late Fall)
                  </p>
                  <p className="text-sm" style={{
                  color: '#5a5a5a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-469">
                    Red Key use 9:00 AM to dusk on weekdays, and continues
                    during normal Sat/Sun open shoot time, weather permitting.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 rounded-xl" style={{
              backgroundColor: '#fff8e8',
              border: '1px solid #f0dfa0'
            }} data-id="element-470">
                <AlertCircleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#8a6a1a'
              }} data-id="element-471" />
                <div data-id="element-472">
                  <p className="text-sm font-semibold mb-0.5" style={{
                  color: '#5a3a0a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-473">
                    Check the Calendar Before You Come Out
                  </p>
                  <p className="text-sm" style={{
                  color: '#6a5a3a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-474">
                    Weather closings are posted on the calendar of events.
                  </p>
                </div>
              </div>
            </div>

            <a href="/18.html" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#1e3d2f',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-475">
              More Details &amp; Photos
              <ArrowRightIcon size={15} data-id="element-476" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}